import { createSelector } from 'reselect';
import { selectors as floorActivitySelectors } from 'modules/entities/modules/elevator-floor-activity';

export const selectTotalTrips = createSelector(
    floorActivitySelectors.selectFloorActivity,
    floorActivity => floorActivity?.totalTrips,
);

export const selectDoorMovements = createSelector(
    floorActivitySelectors.selectFloorActivity,
    floorActivity => floorActivity?.doors ?? [],
);

export const selectFloors = createSelector(
    floorActivitySelectors.selectFloorActivity,
    floorActivity => floorActivity?.floors ?? [],
);
export const selectCurrentFloor = createSelector(floorActivitySelectors.selectFloorActivity,
    floorActivity => floorActivity?.currentFloor?? []
);

export const prepareChartData = createSelector(selectFloors, floorActivity =>
    floorActivity.map(floor => ({
        floor: floor.floor,
        trips: floor.trips,
        doorMovements: 0,
    })),
);

export const selectAverageTrips = createSelector(floorActivitySelectors.selectFloorActivity,
    floorActivity => floorActivity?.averageTrips?? []
)